import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import Table from '../../components/Table';
import Button from '../../components/Button';
import { useHistory } from 'react-router-dom';
import ItemImage from '../../components/ItemImage';
import { FaSearch, FaTrash } from 'react-icons/fa';
import translations from '../../translations/de';
import Delayed from '../Teams/Delayed';
import useModal from '../../customHooks/useModal';
import Modal from '../../components/Modal';
import Paths from '../../constants/paths';

const Players = ({ store }) => {
    const history = useHistory();
    const [playerID, setPlayerID] = useState(null);

    const modalRef = useRef(null);
    const [modal, setModal] = useModal(false, modalRef);

    useEffect(() => {
        store.getPlayers();
    }, [store]);

    const handlePlayer = (id) => {
        history.push(Paths.OUT_OF_LEAGUE_PLAYERS + `/${id}`);
    };

    return (
        <Delayed>
            <>
                {store.players.length !== 0 && (
                    <Table
                        columns={[
                            {
                                Header: 'ID',
                                accessor: 'id',
                                Cell: ({ value, row }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.avatar,
                                accessor: 'avatar',
                                Cell: ({ value, row }) => (
                                    <div>
                                        <ItemImage imgSrc={value} isAvatar={true} listView={true} />
                                    </div>
                                ),
                            },
                            {
                                Header: translations.first_name,
                                accessor: 'first_name',
                                Cell: ({ value, row }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.last_name,
                                accessor: 'last_name',
                                Cell: ({ value, row }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.postion,
                                accessor: 'position',
                                Cell: ({ value, row }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.number,
                                accessor: 'number',
                                Cell: ({ value, row }) => <div>{value}</div>,
                            },
                            {
                                Header: '',
                                accessor: 'action',
                                Cell: ({ row }) => (
                                    <div>
                                        <Button
                                            onClick={() => {
                                                handlePlayer(row.cells[0].value);
                                            }}
                                            title={translations.show}
                                        >
                                            <FaSearch />
                                        </Button>
                                        <Button
                                            title={translations.delete}
                                            onClick={() => {
                                                setPlayerID(row.cells[0].value);
                                                setModal(true);
                                            }}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </div>
                                ),
                            },
                        ]}
                        data={store.players.map(
                            ({
                                id,
                                avatar,
                                first_name,
                                last_name,
                                position,
                                number,
                                deleted_at,
                            }) => {
                                return {
                                    id,
                                    avatar,
                                    first_name,
                                    last_name,
                                    position,
                                    number,
                                    deleted_at,
                                };
                            },
                        )}
                    />
                )}
                {modal && (
                    <Modal
                        title="Delete Player"
                        ref={modalRef}
                        onClose={() => setModal(false)}
                        maxWidth="400px"
                    >
                        <p style={{ color: '#333', marginBottom: '20px' }}>
                            {`Are you sure that you want to delete player with id ${playerID}?`}
                        </p>
                        <div className="Modal-Controls">
                            <Button
                                label="Yes"
                                onClick={() => {
                                    store.deletePlayer(playerID);
                                    setModal(false);
                                }}
                                style={{ width: '80px' }}
                            />
                            <Button
                                label="No"
                                onClick={() => setModal(false)}
                                style={{ width: '80px', marginLeft: '20px' }}
                            />
                        </div>
                    </Modal>
                )}
            </>
        </Delayed>
    );
};

export default observer(Players);
